import _definePage_default_0 from '/home/sphiere/backup-repo/fms-fe/src/pages/[...error].vue?definePage&vue'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/home/sphiere/backup-repo/fms-fe/src/pages/access-control.vue?definePage&vue'
import _definePage_default_3 from '/home/sphiere/backup-repo/fms-fe/src/pages/admin/authentication/forgot-password.vue?definePage&vue'
import _definePage_default_4 from '/home/sphiere/backup-repo/fms-fe/src/pages/admin/authentication/login.vue?definePage&vue'
import _definePage_default_5 from '/home/sphiere/backup-repo/fms-fe/src/pages/admin/authentication/register.vue?definePage&vue'
import _definePage_default_6 from '/home/sphiere/backup-repo/fms-fe/src/pages/admin/authentication/reset-password.vue?definePage&vue'
import _definePage_default_7 from '/home/sphiere/backup-repo/fms-fe/src/pages/admin/facility/index.vue?definePage&vue'
import _definePage_default_8 from '/home/sphiere/backup-repo/fms-fe/src/pages/agency/settings.vue?definePage&vue'
import _definePage_default_9 from '/home/sphiere/backup-repo/fms-fe/src/pages/apps/chat.vue?definePage&vue'
import _definePage_default_10 from '/home/sphiere/backup-repo/fms-fe/src/pages/apps/email/index.vue?definePage&vue'
import _definePage_default_11 from '/home/sphiere/backup-repo/fms-fe/src/pages/apps/logistics/fleet.vue?definePage&vue'
import _definePage_default_12 from '/home/sphiere/backup-repo/fms-fe/src/pages/auth/reset-password.vue?definePage&vue'
import _definePage_default_13 from '/home/sphiere/backup-repo/fms-fe/src/pages/client/settings.vue?definePage&vue'
import _definePage_default_14 from '/home/sphiere/backup-repo/fms-fe/src/pages/contractor/authentication/forgot-password.vue?definePage&vue'
import _definePage_default_15 from '/home/sphiere/backup-repo/fms-fe/src/pages/contractor/authentication/login.vue?definePage&vue'
import _definePage_default_16 from '/home/sphiere/backup-repo/fms-fe/src/pages/contractor/authentication/reset-password.vue?definePage&vue'
import _definePage_default_17 from '/home/sphiere/backup-repo/fms-fe/src/pages/front-pages/checkout.vue?definePage&vue'
import _definePage_default_18 from '/home/sphiere/backup-repo/fms-fe/src/pages/front-pages/help-center/index.vue?definePage&vue'
import _definePage_default_19 from '/home/sphiere/backup-repo/fms-fe/src/pages/front-pages/help-center/article/[title].vue?definePage&vue'
import _definePage_default_20 from '/home/sphiere/backup-repo/fms-fe/src/pages/front-pages/landing-page/index.vue?definePage&vue'
import _definePage_default_21 from '/home/sphiere/backup-repo/fms-fe/src/pages/front-pages/payment.vue?definePage&vue'
import _definePage_default_22 from '/home/sphiere/backup-repo/fms-fe/src/pages/front-pages/pricing.vue?definePage&vue'
import _definePage_default_23 from '/home/sphiere/backup-repo/fms-fe/src/pages/googleads/oauthcallback.vue?definePage&vue'
import _definePage_default_24 from '/home/sphiere/backup-repo/fms-fe/src/pages/landing/index.vue?definePage&vue'
import _definePage_default_25 from '/home/sphiere/backup-repo/fms-fe/src/pages/master/authentication/forgot-password.vue?definePage&vue'
import _definePage_default_26 from '/home/sphiere/backup-repo/fms-fe/src/pages/master/authentication/login.vue?definePage&vue'
import _definePage_default_27 from '/home/sphiere/backup-repo/fms-fe/src/pages/master/authentication/reset-password.vue?definePage&vue'
import _definePage_default_28 from '/home/sphiere/backup-repo/fms-fe/src/pages/master/dashboard/home.vue?definePage&vue'
import _definePage_default_29 from '/home/sphiere/backup-repo/fms-fe/src/pages/meta/callback.vue?definePage&vue'
import _definePage_default_30 from '/home/sphiere/backup-repo/fms-fe/src/pages/not-authorized.vue?definePage&vue'
import _definePage_default_31 from '/home/sphiere/backup-repo/fms-fe/src/pages/pages/account-settings/[tab].vue?definePage&vue'
import _definePage_default_32 from '/home/sphiere/backup-repo/fms-fe/src/pages/pages/audit-log/[id]/[tab].vue?definePage&vue'
import _definePage_default_33 from '/home/sphiere/backup-repo/fms-fe/src/pages/pages/authentication/forgot-password-v1.vue?definePage&vue'
import _definePage_default_34 from '/home/sphiere/backup-repo/fms-fe/src/pages/pages/authentication/forgot-password-v2.vue?definePage&vue'
import _definePage_default_35 from '/home/sphiere/backup-repo/fms-fe/src/pages/pages/authentication/login-v1.vue?definePage&vue'
import _definePage_default_36 from '/home/sphiere/backup-repo/fms-fe/src/pages/pages/authentication/login-v2.vue?definePage&vue'
import _definePage_default_37 from '/home/sphiere/backup-repo/fms-fe/src/pages/pages/authentication/register-multi-steps.vue?definePage&vue'
import _definePage_default_38 from '/home/sphiere/backup-repo/fms-fe/src/pages/pages/authentication/register-v1.vue?definePage&vue'
import _definePage_default_39 from '/home/sphiere/backup-repo/fms-fe/src/pages/pages/authentication/register-v2.vue?definePage&vue'
import _definePage_default_40 from '/home/sphiere/backup-repo/fms-fe/src/pages/pages/authentication/reset-password-v1.vue?definePage&vue'
import _definePage_default_41 from '/home/sphiere/backup-repo/fms-fe/src/pages/pages/authentication/reset-password-v2.vue?definePage&vue'
import _definePage_default_42 from '/home/sphiere/backup-repo/fms-fe/src/pages/pages/authentication/two-steps-v1.vue?definePage&vue'
import _definePage_default_43 from '/home/sphiere/backup-repo/fms-fe/src/pages/pages/authentication/two-steps-v2.vue?definePage&vue'
import _definePage_default_44 from '/home/sphiere/backup-repo/fms-fe/src/pages/pages/authentication/verify-email-v1.vue?definePage&vue'
import _definePage_default_45 from '/home/sphiere/backup-repo/fms-fe/src/pages/pages/authentication/verify-email-v2.vue?definePage&vue'
import _definePage_default_46 from '/home/sphiere/backup-repo/fms-fe/src/pages/pages/client/[id]/[tab].vue?definePage&vue'
import _definePage_default_47 from '/home/sphiere/backup-repo/fms-fe/src/pages/pages/misc/coming-soon.vue?definePage&vue'
import _definePage_default_48 from '/home/sphiere/backup-repo/fms-fe/src/pages/pages/misc/under-maintenance.vue?definePage&vue'
import _definePage_default_49 from '/home/sphiere/backup-repo/fms-fe/src/pages/pages/pricing/callback/index.vue?definePage&vue'
import _definePage_default_50 from '/home/sphiere/backup-repo/fms-fe/src/pages/pages/pricing/callback.vue?definePage&vue'
import _definePage_default_51 from '/home/sphiere/backup-repo/fms-fe/src/pages/pages/report/public-report.vue?definePage&vue'
import _definePage_default_52 from '/home/sphiere/backup-repo/fms-fe/src/pages/pages/user-profile/[tab].vue?definePage&vue'
import _definePage_default_53 from '/home/sphiere/backup-repo/fms-fe/src/pages/user/authentication/forgot-password.vue?definePage&vue'
import _definePage_default_54 from '/home/sphiere/backup-repo/fms-fe/src/pages/user/authentication/login.vue?definePage&vue'
import _definePage_default_55 from '/home/sphiere/backup-repo/fms-fe/src/pages/user/authentication/reset-password.vue?definePage&vue'
import _definePage_default_56 from '/home/sphiere/backup-repo/fms-fe/src/pages/user/dashboard/home.vue?definePage&vue'

export const routes = [
  _mergeRouteRecord(
  {
    path: '/:error(.*)',
    name: '$error',
    component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/[...error].vue'),
    /* no children */
  },
  _definePage_default_0
  ),
  _mergeRouteRecord(
  {
    path: '/access-control',
    name: 'access-control',
    component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/access-control.vue'),
    /* no children */
  },
  _definePage_default_2
  ),
  {
    path: '/admin',
    /* internal name: 'admin' */
    /* no component */
    children: [
      {
        path: 'appointments',
        /* internal name: 'admin-appointments' */
        /* no component */
        children: [
          {
            path: '',
            name: 'admin-appointments',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/admin/appointments/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'authentication',
        /* internal name: 'admin-authentication' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: 'forgot-password',
            name: 'admin-authentication-forgot-password',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/admin/authentication/forgot-password.vue'),
            /* no children */
          },
  _definePage_default_3
  ),
  _mergeRouteRecord(
          {
            path: 'login',
            name: 'admin-authentication-login',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/admin/authentication/login.vue'),
            /* no children */
          },
  _definePage_default_4
  ),
  _mergeRouteRecord(
          {
            path: 'register',
            name: 'admin-authentication-register',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/admin/authentication/register.vue'),
            /* no children */
          },
  _definePage_default_5
  ),
  _mergeRouteRecord(
          {
            path: 'reset-password',
            name: 'admin-authentication-reset-password',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/admin/authentication/reset-password.vue'),
            /* no children */
          },
  _definePage_default_6
  )
        ],
      },
      {
        path: 'bookings',
        /* internal name: 'admin-bookings' */
        /* no component */
        children: [
          {
            path: '',
            name: 'admin-bookings',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/admin/bookings/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'complaints',
        /* internal name: 'admin-complaints' */
        /* no component */
        children: [
          {
            path: '',
            name: 'admin-complaints',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/admin/complaints/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'contractor-companies',
        /* internal name: 'admin-contractor-companies' */
        /* no component */
        children: [
          {
            path: '',
            name: 'admin-contractor-companies',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/admin/contractor-companies/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'contractors',
        /* internal name: 'admin-contractors' */
        /* no component */
        children: [
          {
            path: '',
            name: 'admin-contractors',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/admin/contractors/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'dashboards',
        /* internal name: 'admin-dashboards' */
        /* no component */
        children: [
          {
            path: 'analytics',
            name: 'admin-dashboards-analytics',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/admin/dashboards/analytics.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'facility',
        /* internal name: 'admin-facility' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-facility',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/admin/facility/index.vue'),
            /* no children */
          },
  _definePage_default_7
  )
        ],
      },
      {
        path: 'inventory',
        /* internal name: 'admin-inventory' */
        /* no component */
        children: [
          {
            path: '',
            name: 'admin-inventory',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/admin/inventory/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'maintenance',
        /* internal name: 'admin-maintenance' */
        /* no component */
        children: [
          {
            path: '',
            name: 'admin-maintenance',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/admin/maintenance/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'not-authorized',
        /* internal name: 'admin-not-authorized' */
        /* no component */
        children: [
          {
            path: '',
            name: 'admin-not-authorized',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/admin/not-authorized/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'posts',
        /* internal name: 'admin-posts' */
        /* no component */
        children: [
          {
            path: '',
            name: 'admin-posts',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/admin/posts/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'projects',
        /* internal name: 'admin-projects' */
        /* no component */
        children: [
          {
            path: '',
            name: 'admin-projects',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/admin/projects/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'sla-configuration',
        /* internal name: 'admin-sla-configuration' */
        /* no component */
        children: [
          {
            path: '',
            name: 'admin-sla-configuration',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/admin/sla-configuration/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'sub-roles',
        /* internal name: 'admin-sub-roles' */
        /* no component */
        children: [
          {
            path: '',
            name: 'admin-sub-roles',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/admin/sub-roles/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'units',
        /* internal name: 'admin-units' */
        /* no component */
        children: [
          {
            path: '',
            name: 'admin-units',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/admin/units/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'users',
        /* internal name: 'admin-users' */
        /* no component */
        children: [
          {
            path: '',
            name: 'admin-users',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/admin/users/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'work-order',
        /* internal name: 'admin-work-order' */
        /* no component */
        children: [
          {
            path: '',
            name: 'admin-work-order',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/admin/work-order/index.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/agency',
    /* internal name: 'agency' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'settings',
        name: 'agency-settings',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/agency/settings.vue'),
        /* no children */
      },
  _definePage_default_8
  )
    ],
  },
  {
    path: '/apps',
    /* internal name: 'apps' */
    /* no component */
    children: [
      {
        path: 'academy',
        /* internal name: 'apps-academy' */
        /* no component */
        children: [
          {
            path: 'course-details',
            name: 'apps-academy-course-details',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/apps/academy/course-details.vue'),
            /* no children */
          },
          {
            path: 'dashboard',
            name: 'apps-academy-dashboard',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/apps/academy/dashboard.vue'),
            /* no children */
          },
          {
            path: 'my-course',
            name: 'apps-academy-my-course',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/apps/academy/my-course.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'calendar',
        name: 'apps-calendar',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/apps/calendar.vue'),
        /* no children */
      },
  _mergeRouteRecord(
      {
        path: 'chat',
        name: 'apps-chat',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/apps/chat.vue'),
        /* no children */
      },
  _definePage_default_9
  ),
      {
        path: 'ecommerce',
        /* internal name: 'apps-ecommerce' */
        /* no component */
        children: [
          {
            path: 'customer',
            /* internal name: 'apps-ecommerce-customer' */
            /* no component */
            children: [
              {
                path: 'details',
                /* internal name: 'apps-ecommerce-customer-details' */
                /* no component */
                children: [
                  {
                    path: ':id',
                    name: 'apps-ecommerce-customer-details-id',
                    component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/apps/ecommerce/customer/details/[id].vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'list',
                /* internal name: 'apps-ecommerce-customer-list' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: 'apps-ecommerce-customer-list',
                    component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/apps/ecommerce/customer/list/index.vue'),
                    /* no children */
                  }
                ],
              }
            ],
          },
          {
            path: 'manage-review',
            name: 'apps-ecommerce-manage-review',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/apps/ecommerce/manage-review.vue'),
            /* no children */
          },
          {
            path: 'order',
            /* internal name: 'apps-ecommerce-order' */
            /* no component */
            children: [
              {
                path: 'details',
                /* internal name: 'apps-ecommerce-order-details' */
                /* no component */
                children: [
                  {
                    path: ':id',
                    name: 'apps-ecommerce-order-details-id',
                    component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/apps/ecommerce/order/details/[id].vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'list',
                /* internal name: 'apps-ecommerce-order-list' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: 'apps-ecommerce-order-list',
                    component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/apps/ecommerce/order/list/index.vue'),
                    /* no children */
                  }
                ],
              }
            ],
          },
          {
            path: 'product',
            /* internal name: 'apps-ecommerce-product' */
            /* no component */
            children: [
              {
                path: 'add',
                /* internal name: 'apps-ecommerce-product-add' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: 'apps-ecommerce-product-add',
                    component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/apps/ecommerce/product/add/index.vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'category-list',
                name: 'apps-ecommerce-product-category-list',
                component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/apps/ecommerce/product/category-list.vue'),
                /* no children */
              },
              {
                path: 'list',
                /* internal name: 'apps-ecommerce-product-list' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: 'apps-ecommerce-product-list',
                    component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/apps/ecommerce/product/list/index.vue'),
                    /* no children */
                  }
                ],
              }
            ],
          },
          {
            path: 'referrals',
            name: 'apps-ecommerce-referrals',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/apps/ecommerce/referrals.vue'),
            /* no children */
          },
          {
            path: 'settings',
            name: 'apps-ecommerce-settings',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/apps/ecommerce/settings.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'email',
        /* internal name: 'apps-email' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'apps-email',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/apps/email/index.vue'),
            /* no children */
          },
  _definePage_default_10
  )
        ],
      },
      {
        path: 'invoice',
        /* internal name: 'apps-invoice' */
        /* no component */
        children: [
          {
            path: 'add',
            /* internal name: 'apps-invoice-add' */
            /* no component */
            children: [
              {
                path: '',
                name: 'apps-invoice-add',
                component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/apps/invoice/add/index.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'edit',
            /* internal name: 'apps-invoice-edit' */
            /* no component */
            children: [
              {
                path: ':id',
                name: 'apps-invoice-edit-id',
                component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/apps/invoice/edit/[id].vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'list',
            /* internal name: 'apps-invoice-list' */
            /* no component */
            children: [
              {
                path: '',
                name: 'apps-invoice-list',
                component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/apps/invoice/list/index.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'preview',
            /* internal name: 'apps-invoice-preview' */
            /* no component */
            children: [
              {
                path: ':id',
                name: 'apps-invoice-preview-id',
                component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/apps/invoice/preview/[id].vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'logistics',
        /* internal name: 'apps-logistics' */
        /* no component */
        children: [
          {
            path: 'dashboard',
            name: 'apps-logistics-dashboard',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/apps/logistics/dashboard.vue'),
            /* no children */
          },
  _mergeRouteRecord(
          {
            path: 'fleet',
            name: 'apps-logistics-fleet',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/apps/logistics/fleet.vue'),
            /* no children */
          },
  _definePage_default_11
  )
        ],
      },
      {
        path: 'permissions',
        /* internal name: 'apps-permissions' */
        /* no component */
        children: [
          {
            path: '',
            name: 'apps-permissions',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/apps/permissions/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'roles',
        /* internal name: 'apps-roles' */
        /* no component */
        children: [
          {
            path: '',
            name: 'apps-roles',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/apps/roles/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'user',
        /* internal name: 'apps-user' */
        /* no component */
        children: [
          {
            path: 'list',
            /* internal name: 'apps-user-list' */
            /* no component */
            children: [
              {
                path: '',
                name: 'apps-user-list',
                component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/apps/user/list/index.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'view',
            /* internal name: 'apps-user-view' */
            /* no component */
            children: [
              {
                path: ':id',
                name: 'apps-user-view-id',
                component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/apps/user/view/[id].vue'),
                /* no children */
              }
            ],
          }
        ],
      }
    ],
  },
  {
    path: '/apps/email/:filter',
    name: 'apps-email-filter',
    component: () => import('/src/pages/apps/email/index.vue'),
    /* no children */
  },
  {
    path: '/apps/email/:label',
    name: 'apps-email-label',
    component: () => import('/src/pages/apps/email/index.vue'),
    /* no children */
  },
  {
    path: '/auth',
    /* internal name: 'auth' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'reset-password',
        name: 'auth-reset-password',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/auth/reset-password.vue'),
        /* no children */
      },
  _definePage_default_12
  )
    ],
  },
  {
    path: '/charts',
    /* internal name: 'charts' */
    /* no component */
    children: [
      {
        path: 'apex-chart',
        name: 'charts-apex-chart',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/charts/apex-chart.vue'),
        /* no children */
      },
      {
        path: 'chartjs',
        name: 'charts-chartjs',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/charts/chartjs.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/client',
    /* internal name: 'client' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'settings',
        name: 'client-settings',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/client/settings.vue'),
        /* no children */
      },
  _definePage_default_13
  )
    ],
  },
  {
    path: '/components',
    /* internal name: 'components' */
    /* no component */
    children: [
      {
        path: 'alert',
        name: 'components-alert',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/components/alert.vue'),
        /* no children */
      },
      {
        path: 'avatar',
        name: 'components-avatar',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/components/avatar.vue'),
        /* no children */
      },
      {
        path: 'badge',
        name: 'components-badge',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/components/badge.vue'),
        /* no children */
      },
      {
        path: 'button',
        name: 'components-button',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/components/button.vue'),
        /* no children */
      },
      {
        path: 'chip',
        name: 'components-chip',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/components/chip.vue'),
        /* no children */
      },
      {
        path: 'dialog',
        name: 'components-dialog',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/components/dialog.vue'),
        /* no children */
      },
      {
        path: 'expansion-panel',
        name: 'components-expansion-panel',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/components/expansion-panel.vue'),
        /* no children */
      },
      {
        path: 'list',
        name: 'components-list',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/components/list.vue'),
        /* no children */
      },
      {
        path: 'menu',
        name: 'components-menu',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/components/menu.vue'),
        /* no children */
      },
      {
        path: 'pagination',
        name: 'components-pagination',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/components/pagination.vue'),
        /* no children */
      },
      {
        path: 'progress-circular',
        name: 'components-progress-circular',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/components/progress-circular.vue'),
        /* no children */
      },
      {
        path: 'progress-linear',
        name: 'components-progress-linear',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/components/progress-linear.vue'),
        /* no children */
      },
      {
        path: 'snackbar',
        name: 'components-snackbar',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/components/snackbar.vue'),
        /* no children */
      },
      {
        path: 'tabs',
        name: 'components-tabs',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/components/tabs.vue'),
        /* no children */
      },
      {
        path: 'timeline',
        name: 'components-timeline',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/components/timeline.vue'),
        /* no children */
      },
      {
        path: 'Todo',
        name: 'components-todo',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/components/Todo.vue'),
        /* no children */
      },
      {
        path: 'tooltip',
        name: 'components-tooltip',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/components/tooltip.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/contractor',
    /* internal name: 'contractor' */
    /* no component */
    children: [
      {
        path: 'authentication',
        /* internal name: 'contractor-authentication' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: 'forgot-password',
            name: 'contractor-authentication-forgot-password',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/contractor/authentication/forgot-password.vue'),
            /* no children */
          },
  _definePage_default_14
  ),
  _mergeRouteRecord(
          {
            path: 'login',
            name: 'contractor-authentication-login',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/contractor/authentication/login.vue'),
            /* no children */
          },
  _definePage_default_15
  ),
  _mergeRouteRecord(
          {
            path: 'reset-password',
            name: 'contractor-authentication-reset-password',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/contractor/authentication/reset-password.vue'),
            /* no children */
          },
  _definePage_default_16
  )
        ],
      },
      {
        path: 'calendar',
        /* internal name: 'contractor-calendar' */
        /* no component */
        children: [
          {
            path: 'ContractorWorkOrderDrawer',
            name: 'contractor-calendar-contractor-work-order-drawer',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/contractor/calendar/ContractorWorkOrderDrawer.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'Calendar',
        name: 'contractor-calendar',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/contractor/Calendar.vue'),
        /* no children */
      },
      {
        path: 'dashboard',
        /* internal name: 'contractor-dashboard' */
        /* no component */
        children: [
          {
            path: 'home',
            name: 'contractor-dashboard-home',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/contractor/dashboard/home.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'table',
        /* internal name: 'contractor-table' */
        /* no component */
        children: [
          {
            path: 'WorkOrderTable',
            name: 'contractor-table-work-order-table',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/contractor/table/WorkOrderTable.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'team',
        /* internal name: 'contractor-team' */
        /* no component */
        children: [
          {
            path: '',
            name: 'contractor-team',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/contractor/team/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'work-order',
        /* internal name: 'contractor-work-order' */
        /* no component */
        children: [
          {
            path: '',
            name: 'contractor-work-order',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/contractor/work-order/index.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/dashboards',
    /* internal name: 'dashboards' */
    /* no component */
    children: [
      {
        path: 'analytics',
        name: 'dashboards-analytics',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/dashboards/analytics.vue'),
        /* no children */
      },
      {
        path: 'client',
        name: 'dashboards-client',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/dashboards/client.vue'),
        /* no children */
      },
      {
        path: 'crm',
        name: 'dashboards-crm',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/dashboards/crm.vue'),
        /* no children */
      },
      {
        path: 'ecommerce',
        name: 'dashboards-ecommerce',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/dashboards/ecommerce.vue'),
        /* no children */
      },
      {
        path: 'test',
        name: 'dashboards-test',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/dashboards/test.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/extensions',
    /* internal name: 'extensions' */
    /* no component */
    children: [
      {
        path: 'swiper',
        name: 'extensions-swiper',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/extensions/swiper.vue'),
        /* no children */
      },
      {
        path: 'tour',
        name: 'extensions-tour',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/extensions/tour.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/front-pages',
    /* internal name: 'front-pages' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'checkout',
        name: 'front-pages-checkout',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/front-pages/checkout.vue'),
        /* no children */
      },
  _definePage_default_17
  ),
      {
        path: 'help-center',
        /* internal name: 'front-pages-help-center' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'front-pages-help-center',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/front-pages/help-center/index.vue'),
            /* no children */
          },
  _definePage_default_18
  ),
          {
            path: 'article',
            /* internal name: 'front-pages-help-center-article' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':title',
                name: 'front-pages-help-center-article-title',
                component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/front-pages/help-center/article/[title].vue'),
                /* no children */
              },
  _definePage_default_19
  )
            ],
          }
        ],
      },
      {
        path: 'landing-page',
        /* internal name: 'front-pages-landing-page' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'front-pages-landing-page',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/front-pages/landing-page/index.vue'),
            /* no children */
          },
  _definePage_default_20
  )
        ],
      },
  _mergeRouteRecord(
      {
        path: 'payment',
        name: 'front-pages-payment',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/front-pages/payment.vue'),
        /* no children */
      },
  _definePage_default_21
  ),
  _mergeRouteRecord(
      {
        path: 'pricing',
        name: 'front-pages-pricing',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/front-pages/pricing.vue'),
        /* no children */
      },
  _definePage_default_22
  )
    ],
  },
  {
    path: '/googleads',
    /* internal name: 'googleads' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'oauthcallback',
        name: 'googleads-oauthcallback',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/googleads/oauthcallback.vue'),
        /* no children */
      },
  _definePage_default_23
  )
    ],
  },
  {
    path: '/guest',
    /* internal name: 'guest' */
    /* no component */
    children: [
      {
        path: 'complaint',
        name: 'guest-complaint',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/guest/complaint.vue'),
        /* no children */
        meta: {
          "layout": "blank"
        }
      },
      {
        path: 'complaint-token',
        name: 'guest-complaint-token',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/guest/complaint-token.vue'),
        /* no children */
        meta: {
          "layout": "blank"
        }
      }
    ],
  },
  {
    path: '/landing',
    /* internal name: 'landing' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'landing',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/landing/index.vue'),
        /* no children */
      },
  _definePage_default_24
  )
    ],
  },
  {
    path: '/master',
    /* internal name: 'master' */
    /* no component */
    children: [
      {
        path: 'authentication',
        /* internal name: 'master-authentication' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: 'forgot-password',
            name: 'master-authentication-forgot-password',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/master/authentication/forgot-password.vue'),
            /* no children */
          },
  _definePage_default_25
  ),
  _mergeRouteRecord(
          {
            path: 'login',
            name: 'master-authentication-login',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/master/authentication/login.vue'),
            /* no children */
          },
  _definePage_default_26
  ),
  _mergeRouteRecord(
          {
            path: 'reset-password',
            name: 'master-authentication-reset-password',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/master/authentication/reset-password.vue'),
            /* no children */
          },
  _definePage_default_27
  )
        ],
      },
      {
        path: 'dashboard',
        /* internal name: 'master-dashboard' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: 'home',
            name: 'master-dashboard-home',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/master/dashboard/home.vue'),
            /* no children */
          },
  _definePage_default_28
  )
        ],
      },
      {
        path: 'meetings',
        /* internal name: 'master-meetings' */
        /* no component */
        children: [
          {
            path: 'availability',
            name: 'master-meetings-availability',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/master/meetings/availability.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/meta',
    /* internal name: 'meta' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'callback',
        name: 'meta-callback',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/meta/callback.vue'),
        /* no children */
      },
  _definePage_default_29
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/not-authorized',
    name: 'not-authorized',
    component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/not-authorized.vue'),
    /* no children */
  },
  _definePage_default_30
  ),
  {
    path: '/pages',
    /* internal name: 'pages' */
    /* no component */
    children: [
      {
        path: 'access-mgmt',
        /* internal name: 'pages-access-mgmt' */
        /* no component */
        children: [
          {
            path: '',
            name: 'pages-access-mgmt',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/access-mgmt/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'account-settings',
        /* internal name: 'pages-account-settings' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':tab',
            name: 'pages-account-settings-tab',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/account-settings/[tab].vue'),
            /* no children */
          },
  _definePage_default_31
  )
        ],
      },
      {
        path: 'asset',
        /* internal name: 'pages-asset' */
        /* no component */
        children: [
          {
            path: '',
            name: 'pages-asset',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/asset/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'assets',
        /* internal name: 'pages-assets' */
        /* no component */
        children: [
          {
            path: '',
            name: 'pages-assets',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/assets/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'audit-log',
        /* internal name: 'pages-audit-log' */
        /* no component */
        children: [
          {
            path: '',
            name: 'pages-audit-log',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/audit-log/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            /* internal name: 'pages-audit-log-id' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':tab',
                name: 'pages-audit-log-id-tab',
                component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/audit-log/[id]/[tab].vue'),
                /* no children */
              },
  _definePage_default_32
  )
            ],
          }
        ],
      },
      {
        path: 'authentication',
        /* internal name: 'pages-authentication' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: 'forgot-password-v1',
            name: 'pages-authentication-forgot-password-v1',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/authentication/forgot-password-v1.vue'),
            /* no children */
          },
  _definePage_default_33
  ),
  _mergeRouteRecord(
          {
            path: 'forgot-password-v2',
            name: 'pages-authentication-forgot-password-v2',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/authentication/forgot-password-v2.vue'),
            /* no children */
          },
  _definePage_default_34
  ),
  _mergeRouteRecord(
          {
            path: 'login-v1',
            name: 'pages-authentication-login-v1',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/authentication/login-v1.vue'),
            /* no children */
          },
  _definePage_default_35
  ),
  _mergeRouteRecord(
          {
            path: 'login-v2',
            name: 'pages-authentication-login-v2',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/authentication/login-v2.vue'),
            /* no children */
          },
  _definePage_default_36
  ),
  _mergeRouteRecord(
          {
            path: 'register-multi-steps',
            name: 'pages-authentication-register-multi-steps',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/authentication/register-multi-steps.vue'),
            /* no children */
          },
  _definePage_default_37
  ),
  _mergeRouteRecord(
          {
            path: 'register-v1',
            name: 'pages-authentication-register-v1',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/authentication/register-v1.vue'),
            /* no children */
          },
  _definePage_default_38
  ),
  _mergeRouteRecord(
          {
            path: 'register-v2',
            name: 'pages-authentication-register-v2',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/authentication/register-v2.vue'),
            /* no children */
          },
  _definePage_default_39
  ),
  _mergeRouteRecord(
          {
            path: 'reset-password-v1',
            name: 'pages-authentication-reset-password-v1',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/authentication/reset-password-v1.vue'),
            /* no children */
          },
  _definePage_default_40
  ),
  _mergeRouteRecord(
          {
            path: 'reset-password-v2',
            name: 'pages-authentication-reset-password-v2',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/authentication/reset-password-v2.vue'),
            /* no children */
          },
  _definePage_default_41
  ),
  _mergeRouteRecord(
          {
            path: 'two-steps-v1',
            name: 'pages-authentication-two-steps-v1',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/authentication/two-steps-v1.vue'),
            /* no children */
          },
  _definePage_default_42
  ),
  _mergeRouteRecord(
          {
            path: 'two-steps-v2',
            name: 'pages-authentication-two-steps-v2',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/authentication/two-steps-v2.vue'),
            /* no children */
          },
  _definePage_default_43
  ),
  _mergeRouteRecord(
          {
            path: 'verify-email-v1',
            name: 'pages-authentication-verify-email-v1',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/authentication/verify-email-v1.vue'),
            /* no children */
          },
  _definePage_default_44
  ),
  _mergeRouteRecord(
          {
            path: 'verify-email-v2',
            name: 'pages-authentication-verify-email-v2',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/authentication/verify-email-v2.vue'),
            /* no children */
          },
  _definePage_default_45
  )
        ],
      },
      {
        path: 'brief-mgmt',
        /* internal name: 'pages-brief-mgmt' */
        /* no component */
        children: [
          {
            path: '',
            name: 'pages-brief-mgmt',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/brief-mgmt/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            name: 'pages-brief-mgmt-id',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/brief-mgmt/[id].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'cards',
        /* internal name: 'pages-cards' */
        /* no component */
        children: [
          {
            path: 'card-actions',
            name: 'pages-cards-card-actions',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/cards/card-actions.vue'),
            /* no children */
          },
          {
            path: 'card-advance',
            name: 'pages-cards-card-advance',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/cards/card-advance.vue'),
            /* no children */
          },
          {
            path: 'card-basic',
            name: 'pages-cards-card-basic',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/cards/card-basic.vue'),
            /* no children */
          },
          {
            path: 'card-statistics',
            name: 'pages-cards-card-statistics',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/cards/card-statistics.vue'),
            /* no children */
          },
          {
            path: 'card-widgets',
            name: 'pages-cards-card-widgets',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/cards/card-widgets.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'client',
        /* internal name: 'pages-client' */
        /* no component */
        children: [
          {
            path: '',
            name: 'pages-client',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/client/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            /* internal name: 'pages-client-id' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':tab',
                name: 'pages-client-id-tab',
                component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/client/[id]/[tab].vue'),
                /* no children */
              },
  _definePage_default_46
  )
            ],
          }
        ],
      },
      {
        path: 'client_test',
        name: 'pages-client-test',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/client_test.vue'),
        /* no children */
      },
      {
        path: 'client-brief-management',
        name: 'pages-client-brief-management',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/client-brief-management.vue'),
        /* no children */
      },
      {
        path: 'client-projects',
        name: 'pages-client-projects',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/client-projects.vue'),
        /* no children */
      },
      {
        path: 'client-reports',
        name: 'pages-client-reports',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/client-reports.vue'),
        /* no children */
      },
      {
        path: 'client-request-access',
        name: 'pages-client-request-access',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/client-request-access.vue'),
        /* no children */
      },
      {
        path: 'client-request-data-access',
        name: 'pages-client-request-data-access',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/client-request-data-access.vue'),
        /* no children */
      },
      {
        path: 'client-team-management',
        name: 'pages-client-team-management',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/client-team-management.vue'),
        /* no children */
      },
      {
        path: 'data-mgmt',
        /* internal name: 'pages-data-mgmt' */
        /* no component */
        children: [
          {
            path: '',
            name: 'pages-data-mgmt',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/data-mgmt/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'dialog-examples',
        /* internal name: 'pages-dialog-examples' */
        /* no component */
        children: [
          {
            path: '',
            name: 'pages-dialog-examples',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/dialog-examples/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'faq',
        name: 'pages-faq',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/faq.vue'),
        /* no children */
      },
      {
        path: 'flow',
        name: 'pages-flow',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/flow.vue'),
        /* no children */
      },
      {
        path: 'form',
        /* internal name: 'pages-form' */
        /* no component */
        children: [
          {
            path: '',
            name: 'pages-form',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/form/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            name: 'pages-form-id',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/form/[id].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'icons',
        name: 'pages-icons',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/icons.vue'),
        /* no children */
      },
      {
        path: 'inventory',
        /* internal name: 'pages-inventory' */
        /* no component */
        children: [
          {
            path: '',
            name: 'pages-inventory',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/inventory/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'invoice',
        /* internal name: 'pages-invoice' */
        /* no component */
        children: [
          {
            path: '',
            name: 'pages-invoice',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/invoice/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'lease',
        /* internal name: 'pages-lease' */
        /* no component */
        children: [
          {
            path: '',
            name: 'pages-lease',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/lease/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'misc',
        /* internal name: 'pages-misc' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: 'coming-soon',
            name: 'pages-misc-coming-soon',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/misc/coming-soon.vue'),
            /* no children */
          },
  _definePage_default_47
  ),
          {
            path: 'internal-server-error',
            name: 'pages-misc-internal-server-error',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/misc/internal-server-error.vue'),
            /* no children */
            meta: {
              "layout": "blank"
            }
          },
          {
            path: 'not-authorized',
            name: 'pages-misc-not-authorized',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/misc/not-authorized.vue'),
            /* no children */
            meta: {
              "layout": "blank"
            }
          },
          {
            path: 'not-found',
            name: 'pages-misc-not-found',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/misc/not-found.vue'),
            /* no children */
            meta: {
              "layout": "blank"
            }
          },
  _mergeRouteRecord(
          {
            path: 'under-maintenance',
            name: 'pages-misc-under-maintenance',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/misc/under-maintenance.vue'),
            /* no children */
          },
  _definePage_default_48
  )
        ],
      },
      {
        path: 'payment',
        /* internal name: 'pages-payment' */
        /* no component */
        children: [
          {
            path: '',
            name: 'pages-payment',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/payment/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'playbook',
        /* internal name: 'pages-playbook' */
        /* no component */
        children: [
          {
            path: '',
            name: 'pages-playbook',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/playbook/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'pricing',
        name: 'pages-pricing-parent',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/pricing.vue'),
        children: [
          {
            path: '',
            name: 'pages-pricing',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/pricing/index.vue'),
            /* no children */
          },
  _mergeRouteRecord(
          {
            path: 'callback',
            name: 'pages-pricing-callback-parent',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/pricing/callback.vue'),
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'pages-pricing-callback',
                component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/pricing/callback/index.vue'),
                /* no children */
              },
  _definePage_default_49
  )
            ],
          },
  _definePage_default_50
  )
        ],
      },
      {
        path: 'project',
        /* internal name: 'pages-project' */
        /* no component */
        children: [
          {
            path: '',
            name: 'pages-project',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/project/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'report',
        /* internal name: 'pages-report' */
        /* no component */
        children: [
          {
            path: '',
            name: 'pages-report',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/report/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            name: 'pages-report-id',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/report/[id].vue'),
            /* no children */
          },
          {
            path: 'custom-reports-:id',
            name: 'pages-report-custom-reports-id',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/report/custom-reports-[id].vue'),
            /* no children */
          },
          {
            path: 'edit-:id',
            name: 'pages-report-edit-id',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/report/edit-[id].vue'),
            /* no children */
          },
          {
            path: 'preview-report-:id',
            name: 'pages-report-preview-report-id',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/report/preview-report-[id].vue'),
            /* no children */
          },
  _mergeRouteRecord(
          {
            path: 'public-report',
            name: 'pages-report-public-report',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/report/public-report.vue'),
            /* no children */
          },
  _definePage_default_51
  )
        ],
      },
      {
        path: 'request-access',
        /* internal name: 'pages-request-access' */
        /* no component */
        children: [
          {
            path: '',
            name: 'pages-request-access',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/request-access/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'setting',
        /* internal name: 'pages-setting' */
        /* no component */
        children: [
          {
            path: '',
            name: 'pages-setting',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/setting/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'staff',
        name: 'pages-staff',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/staff.vue'),
        /* no children */
      },
      {
        path: 'team-member',
        /* internal name: 'pages-team-member' */
        /* no component */
        children: [
          {
            path: '',
            name: 'pages-team-member',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/team-member/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'template',
        /* internal name: 'pages-template' */
        /* no component */
        children: [
          {
            path: '',
            name: 'pages-template',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/template/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            name: 'pages-template-id',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/template/[id].vue'),
            /* no children */
          },
          {
            path: 'form',
            /* internal name: 'pages-template-form' */
            /* no component */
            children: [
              {
                path: '',
                name: 'pages-template-form',
                component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/template/form/index.vue'),
                /* no children */
              },
              {
                path: ':id',
                name: 'pages-template-form-id',
                component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/template/form/[id].vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'tenant',
        /* internal name: 'pages-tenant' */
        /* no component */
        children: [
          {
            path: '',
            name: 'pages-tenant',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/tenant/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'typography',
        name: 'pages-typography',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/typography.vue'),
        /* no children */
      },
      {
        path: 'user-profile',
        /* internal name: 'pages-user-profile' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':tab',
            name: 'pages-user-profile-tab',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/user-profile/[tab].vue'),
            /* no children */
          },
  _definePage_default_52
  )
        ],
      },
      {
        path: 'vendor',
        /* internal name: 'pages-vendor' */
        /* no component */
        children: [
          {
            path: '',
            name: 'pages-vendor',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/pages/vendor/index.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/scan',
    /* internal name: 'scan' */
    /* no component */
    children: [
      {
        path: 'details',
        name: 'scan-details',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/scan/details.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/tables',
    /* internal name: 'tables' */
    /* no component */
    children: [
      {
        path: 'data-table',
        name: 'tables-data-table',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/tables/data-table.vue'),
        /* no children */
      },
      {
        path: 'simple-table',
        name: 'tables-simple-table',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/tables/simple-table.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/user',
    /* internal name: 'user' */
    /* no component */
    children: [
      {
        path: 'announcements',
        /* internal name: 'user-announcements' */
        /* no component */
        children: [
          {
            path: '',
            name: 'user-announcements',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/user/announcements/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'appointments',
        /* internal name: 'user-appointments' */
        /* no component */
        children: [
          {
            path: '',
            name: 'user-appointments',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/user/appointments/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'authentication',
        /* internal name: 'user-authentication' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: 'forgot-password',
            name: 'user-authentication-forgot-password',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/user/authentication/forgot-password.vue'),
            /* no children */
          },
  _definePage_default_53
  ),
  _mergeRouteRecord(
          {
            path: 'login',
            name: 'user-authentication-login',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/user/authentication/login.vue'),
            /* no children */
          },
  _definePage_default_54
  ),
  _mergeRouteRecord(
          {
            path: 'reset-password',
            name: 'user-authentication-reset-password',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/user/authentication/reset-password.vue'),
            /* no children */
          },
  _definePage_default_55
  )
        ],
      },
      {
        path: 'bookings',
        /* internal name: 'user-bookings' */
        /* no component */
        children: [
          {
            path: '',
            name: 'user-bookings',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/user/bookings/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'community',
        /* internal name: 'user-community' */
        /* no component */
        children: [
          {
            path: '',
            name: 'user-community',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/user/community/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'contacts',
        /* internal name: 'user-contacts' */
        /* no component */
        children: [
          {
            path: '',
            name: 'user-contacts',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/user/contacts/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'dashboard',
        /* internal name: 'user-dashboard' */
        /* no component */
        children: [
          {
            path: 'components',
            /* internal name: 'user-dashboard-components' */
            /* no component */
            children: [
              {
                path: 'DashboardStats',
                name: 'user-dashboard-components-dashboard-stats',
                component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/user/dashboard/components/DashboardStats.vue'),
                /* no children */
              },
              {
                path: 'DashboardWelcome',
                name: 'user-dashboard-components-dashboard-welcome',
                component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/user/dashboard/components/DashboardWelcome.vue'),
                /* no children */
              },
              {
                path: 'DesktopDashboard',
                name: 'user-dashboard-components-desktop-dashboard',
                component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/user/dashboard/components/DesktopDashboard.vue'),
                /* no children */
              },
              {
                path: 'FeaturedContent',
                name: 'user-dashboard-components-featured-content',
                component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/user/dashboard/components/FeaturedContent.vue'),
                /* no children */
              },
              {
                path: 'mobile',
                /* internal name: 'user-dashboard-components-mobile' */
                /* no component */
                children: [
                  {
                    path: 'MobileBottomNav',
                    name: 'user-dashboard-components-mobile-mobile-bottom-nav',
                    component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/user/dashboard/components/mobile/MobileBottomNav.vue'),
                    /* no children */
                  },
                  {
                    path: 'MobileDashboard',
                    name: 'user-dashboard-components-mobile-mobile-dashboard',
                    component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/user/dashboard/components/mobile/MobileDashboard.vue'),
                    /* no children */
                  },
                  {
                    path: 'MobileHeader',
                    name: 'user-dashboard-components-mobile-mobile-header',
                    component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/user/dashboard/components/mobile/MobileHeader.vue'),
                    /* no children */
                  },
                  {
                    path: 'MobileHighlights',
                    name: 'user-dashboard-components-mobile-mobile-highlights',
                    component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/user/dashboard/components/mobile/MobileHighlights.vue'),
                    /* no children */
                  },
                  {
                    path: 'MobileNotices',
                    name: 'user-dashboard-components-mobile-mobile-notices',
                    component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/user/dashboard/components/mobile/MobileNotices.vue'),
                    /* no children */
                  },
                  {
                    path: 'MobileQuickActions',
                    name: 'user-dashboard-components-mobile-mobile-quick-actions',
                    component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/user/dashboard/components/mobile/MobileQuickActions.vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'MobileDashboard',
                name: 'user-dashboard-components-mobile-dashboard',
                component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/user/dashboard/components/MobileDashboard.vue'),
                /* no children */
              },
              {
                path: 'QuickAccess',
                name: 'user-dashboard-components-quick-access',
                component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/user/dashboard/components/QuickAccess.vue'),
                /* no children */
              },
              {
                path: 'RecentUpdates',
                name: 'user-dashboard-components-recent-updates',
                component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/user/dashboard/components/RecentUpdates.vue'),
                /* no children */
              }
            ],
          },
  _mergeRouteRecord(
          {
            path: 'home',
            name: 'user-dashboard-home',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/user/dashboard/home.vue'),
            /* no children */
          },
  _definePage_default_56
  )
        ],
      },
      {
        path: 'emergencies',
        /* internal name: 'user-emergencies' */
        /* no component */
        children: [
          {
            path: '',
            name: 'user-emergencies',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/user/emergencies/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'facilities',
        /* internal name: 'user-facilities' */
        /* no component */
        children: [
          {
            path: '',
            name: 'user-facilities',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/user/facilities/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'forms',
        /* internal name: 'user-forms' */
        /* no component */
        children: [
          {
            path: '',
            name: 'user-forms',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/user/forms/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'guard-house',
        /* internal name: 'user-guard-house' */
        /* no component */
        children: [
          {
            path: '',
            name: 'user-guard-house',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/user/guard-house/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'links',
        /* internal name: 'user-links' */
        /* no component */
        children: [
          {
            path: '',
            name: 'user-links',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/user/links/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'manuals',
        /* internal name: 'user-manuals' */
        /* no component */
        children: [
          {
            path: '',
            name: 'user-manuals',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/user/manuals/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'posts',
        /* internal name: 'user-posts' */
        /* no component */
        children: [
          {
            path: '',
            name: 'user-posts',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/user/posts/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'requests',
        /* internal name: 'user-requests' */
        /* no component */
        children: [
          {
            path: '',
            name: 'user-requests',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/user/requests/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'support',
        /* internal name: 'user-support' */
        /* no component */
        children: [
          {
            path: '',
            name: 'user-support',
            component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/user/support/index.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/wizard-examples',
    /* internal name: 'wizard-examples' */
    /* no component */
    children: [
      {
        path: 'checkout',
        name: 'wizard-examples-checkout',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/wizard-examples/checkout.vue'),
        /* no children */
      },
      {
        path: 'create-deal',
        name: 'wizard-examples-create-deal',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/wizard-examples/create-deal.vue'),
        /* no children */
      },
      {
        path: 'property-listing',
        name: 'wizard-examples-property-listing',
        component: () => import('/home/sphiere/backup-repo/fms-fe/src/pages/wizard-examples/property-listing.vue'),
        /* no children */
      }
    ],
  }
]
